<template>
    <v-dialog
        v-model="visible"
        width="700"
        >
        <v-card>
            <div class="drawer-header d-flex align-center mb-4">
                <span class="font-weight-semibold text-base text--primary">{{$t('tailorImg.title')}}</span>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    small
                    @click="$emit('cancelHandel')"
                    >
                    <v-icon size="22">
                        {{ icons.mdiClose }}
                    </v-icon>
                </v-btn>
            </div>
            
            <v-container>
                <v-row>
                    <v-col xs="12" md="6" :style="{ height: '350px' }">
                        <vue-cropper
                            class="background-repeat"
                            ref="cropper"
                            :img="options.img"
                            :info="true"
                            :auto-crop="options.autoCrop"
                            :auto-crop-width="options.autoCropWidth"
                            :auto-crop-height="options.autoCropHeight"
                            :fixed-box="options.fixedBox"
                            :outputSize="options.size"
                            :outputType="options.outputType"
                            :full="options.full"
                            :canMove="options.canMove"
                            :canMoveBox="options.canMoveBox"
                            :original="options.original"
                            :fixed="options.fixed"
                            :fixedNumber="options.fixedNumber"
                            :centerBox="options.centerBox"
                            :infoTrue="options.infoTrue"
                            @realTime="realTime"
                        >
                        </vue-cropper>
                    </v-col>
                    <v-col xs="12" md="6" class="img-box">
                        <div :style="previews.div" class="avatar-upload-preview">
                            <img :src="previews.url" :style="previews.img" />
                        </div>
                    </v-col>
                </v-row>
                <div class="mb-5">
                    <v-file-input
                        :rules="rules"
                        show-size
                        hide-details="auto"
                        :label="$t('tailorImg.uploadText')">
                    </v-file-input>
                </div>
                <v-row class="pb-2">
                    <v-col class="flex-grow-0">
                        <v-btn outlined @click="changeScale(1)" small>
                            <v-icon>{{ icons.mdiPlus }}</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col class="flex-grow-0">
                        <v-btn outlined @click="changeScale(-1)" small>
                            <v-icon>{{ icons.mdiMinus }}</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col class="flex-grow-0">
                        <v-btn outlined @click="rotateLeft" small>
                            <v-icon>{{ icons.mdiUndo }}</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col class="flex-grow-0">
                        <v-btn outlined @click="rotateRight" small>
                            <v-icon>{{ icons.mdiRedo }}</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col md="4" sm="12" class="text-center">
                        <v-btn color="primary" small :loading="iconLoading" @click="finish('blob')">{{$t('btn.subBtn')}}</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiPlus, mdiMinus, mdiUndo, mdiRedo, mdiClose } from '@mdi/js';
import store from '@/store'

    export default {
        name: 'avatarModal',
        data () {
            return {
                options: {
                    img: '', // 裁剪图片的地址
                    info: true, // 裁剪框的大小信息
                    canMove: false, //上传图片是否可以移动
                    outputSize: 0.5, // 裁剪生成图片的质量
                    // outputType: 'jpeg', // 裁剪生成图片的格式
                    canScale: false, // 图片是否允许滚轮缩放
                    autoCrop: true, // 是否默认生成截图框
                    autoCropWidth: 150, // 默认生成截图框宽度
                    autoCropHeight: 150, // 默认生成截图框高度
                    fixedBox: false, // 固定截图框大小 不允许改变
                    fixed: true, // 是否开启截图框宽高固定比例
                    fixedNumber: [5, 5], // 截图框的宽高比例
                    full: true, // 是否输出原图比例的截图
                    canMoveBox: true, // 截图框能否拖动
                    original: false, // 上传图片按照原始比例渲染
                    centerBox: true, // 截图框是否被限制在图片里面
                    infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
                },
                previews: {}, // 裁剪之后的结果
                icons: {
                    mdiRedo,
                    mdiUndo,
                    mdiMinus,
                    mdiPlus,
                    mdiClose
                },
                rules: [
                    value => this.beforeUpload(value)
                ],
            }
        },
        props: {
            visible: Boolean,
            iconLoading: Boolean,
        },
        methods: {
            cancelHandel () {
                this.$emit("cancelHandel")
            },
            // 图片放大/缩小
            changeScale (num) {
                num = num || 1
                this.$refs.cropper.changeScale(num)
            },
            // 左旋转
            rotateLeft () {
                this.$refs.cropper.rotateLeft()
            },
            // 右旋转
            rotateRight () {
                this.$refs.cropper.rotateRight()
            },
            beforeUpload (file) {
                if(!file || file.length == 0) {
                    return true
                }
                // const isJpgOrPng = file[0].type === 'image/jpeg' || file[0].type === 'image/png';
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                if (!isJpgOrPng) {
					// store.dispatch('snackbar/openSnackbar',{
					// 	snackbarText: ,
					// 	colorType: 'error'
					// })
                    return this.$t('tailorImg.typeErr')
                }
                const isLt2M = file.size / 1024  < 200;
                if (!isLt2M) {
					// store.dispatch('snackbar/openSnackbar',{
					// 	snackbarText: this.$t('tailorImg.sizeErr'),
					// 	colorType: 'error'
					// })
                    return this.$t('tailorImg.sizeErr')
                }
                const reader = new FileReader()
                // 转化为base64
                reader.readAsDataURL(file)
                reader.onload = () => {
                    // 获取到需要剪裁的图片 展示到剪裁框中
                    this.options.img = reader.result
                }
                return true
            },
            // 上传图片（点击保存按钮）
            finish (type) {
                if (this.previews.url) {
                    // getCropData获取截图的base64数据  getCropBlob获取截图的blob数据
                    this.$refs.cropper.getCropBlob((data, val) => {
                        this.$emit('headSave', data)
                    })
                } else {
					store.dispatch('snackbar/openSnackbar',{
						snackbarText: this.$t('tailorImg.noFile'),
						colorType: 'error'
					})
                }
            },
            // 裁剪之后的数据
            realTime (data) {
                this.previews = data
            }
        }
    }
</script>

<style scoped lang="scss">
.img-box {
    height: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
    .avatar-upload-preview {
        overflow: hidden;
        border-radius: 50%;
    }
}
.drawer-header {
    border-bottom: 1px solid #f0f0f0;
}
.background-repeat {
    background-repeat: repeat;
}
</style>
